import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { eFilterFieldType } from '@hub/generated/enums';
import { AFilterBase, FilterCollection, FilterValueCollection, GridDto } from '@hub/generated/models';
import { FilterService } from '@hub/services/FilterService';

@Component({
  selector: 'app-filterSelector',
  templateUrl: './filterSelector.component.html',
  styleUrls: ['./filterSelector.component.scss']
})
export class FilterSelectorComponent implements OnInit {
  constructor(private service: FilterService) {
  }

  @Input()
  public grid: GridDto;

  @Output()
  public onFilterChange: EventEmitter<GridDto> = new EventEmitter<GridDto>();

  public filters: AFilterBase[];
  public filterCollection: FilterCollection;
  public Type = eFilterFieldType;

  public ngOnInit(): void {
    this.filterCollection = this.grid.AppliedFilters;
  }

  public filterChanged(value: FilterValueCollection): void {
    if (!this.filterCollection)
      this.filterCollection = new FilterCollection();

    if (!this.filterCollection.List)
      this.filterCollection.List = [ value ];
    else {
      let collection: FilterValueCollection = this.filterCollection.List.find((item) => item.ColumnName == value.ColumnName)
      if (!collection)
        this.filterCollection.List.push(value);
      else
        collection.List = value.List;
    }

    this.service.Clear();
    this.grid.AppliedFilters = this.filterCollection;
    this.onFilterChange.emit(this.grid);
  }

  public getFilters(): AFilterBase[] {
    if (!this.filters) {
      this.filters = [];
      this.grid.Filters
        .forEach(element => {
          if (element != null) {
            if (element.FilterType !== eFilterFieldType.Container) {
              this.filters.push(element);
            } else {
              this.getSubFilters(element, element.ColumnName, this.filters);
            }
          }
        });

        this.filters = this.filters
          .filter(f => f.FilterType !== eFilterFieldType.Container)
          .sort((a, b) => a.SortOrder - b.SortOrder);
     }

     return this.filters;
  }

  private getSubFilters(filter: AFilterBase, name: string, target: AFilterBase[]): void {
    if (filter.SubFilters != null && filter.SubFilters.length > 0) {
      filter.SubFilters.forEach(element => {
        if (element.FilterType !== eFilterFieldType.Container) {
          element.ColumnName = name + "|" + element.ColumnName;
          target.push(element);
        }
        else
          this.getSubFilters(element, name + "|" + element.ColumnName, target);
      });
    }
  }
}
